import type { FunctionComponent } from 'react';
import type { CountdownProps, CountdownRenderProps } from 'react-countdown';
import Countdown from 'react-countdown';

interface UpcomingEventCountdownProps extends Omit<CountdownProps, 'renderer'> {
  omitSecondsWhenIsDaysAway?: boolean;
}

const UpcomingEventCountdown: FunctionComponent<UpcomingEventCountdownProps> = ({
  omitSecondsWhenIsDaysAway,
  ...props
}) => {
  return (
    <Countdown
      renderer={({ formatted, days }: CountdownRenderProps) => {
        const { hours, minutes, seconds } = formatted;

        const isDaysAway = days > 0;

        return (
          <span>
            {isDaysAway && `${days}d `}
            {`${hours}h ${minutes}m `}
            {((isDaysAway && !omitSecondsWhenIsDaysAway) || !isDaysAway) && `${seconds}s`}
          </span>
        );
      }}
      {...props}
    />
  );
};

export { UpcomingEventCountdown, type UpcomingEventCountdownProps };
